export enum ConflictWithOrderlinesDialogResult {
  DISMISS,
  ADJUST_ORDER_PLAN
}
